import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_item_with_category_file_import_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.VarcharArrayDatatypeInterface;
    item_name: fromDatatype.VarcharArrayDatatypeInterface;
    item_type: fromDatatype.VarcharArrayDatatypeInterface;
    sub_type: fromDatatype.VarcharArrayDatatypeInterface;
    base_uom: fromDatatype.VarcharArrayDatatypeInterface;
    ean_code: fromDatatype.VarcharArrayDatatypeInterface;
    currency: fromDatatype.VarcharArrayDatatypeInterface;
    prefix: fromDatatype.VarcharArrayDatatypeInterface;
    hdr_remarks: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    tax_applicable: boolean;
    tax_country: fromDatatype.VarcharArrayDatatypeInterface;
    input_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    imput_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    input_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    output_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    output_tax_rate: fromDatatype.NumericDatatypeInterface;
    input_withholding_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    input_withholding_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    input_withholding_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_withholding_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    output_withholding_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    output_withholding_tax_rate: fromDatatype.NumericDatatypeInterface;
    height: fromDatatype.NumericDatatypeInterface;
    weight: fromDatatype.NumericDatatypeInterface;
    width: fromDatatype.NumericDatatypeInterface;
    length: fromDatatype.NumericDatatypeInterface;
    ecom_sync: boolean;
    serialized: boolean;
    category_group_0_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_0_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_1_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_1_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_2_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_2_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_3_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_3_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_4_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_4_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_5_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_5_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_6_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_6_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_7_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_7_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_8_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_8_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_9_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_9_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_10_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_10_code: fromDatatype.VarcharArrayDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;    
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_fi_item_with_category_file_import_RowClass implements bl_fi_item_with_category_file_import_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.VarcharArrayDatatypeInterface;
    item_name: fromDatatype.VarcharArrayDatatypeInterface;
    item_type: fromDatatype.VarcharArrayDatatypeInterface;
    sub_type: fromDatatype.VarcharArrayDatatypeInterface;
    base_uom: fromDatatype.VarcharArrayDatatypeInterface;
    ean_code: fromDatatype.VarcharArrayDatatypeInterface;
    currency: fromDatatype.VarcharArrayDatatypeInterface;
    prefix: fromDatatype.VarcharArrayDatatypeInterface;
    hdr_remarks: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    tax_applicable: boolean;
    tax_country: fromDatatype.VarcharArrayDatatypeInterface;
    input_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    imput_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    input_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    output_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    output_tax_rate: fromDatatype.NumericDatatypeInterface;
    input_withholding_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    input_withholding_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    input_withholding_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_withholding_tax_type: fromDatatype.VarcharArrayDatatypeInterface;
    output_withholding_tax_code: fromDatatype.VarcharArrayDatatypeInterface;
    output_withholding_tax_rate: fromDatatype.NumericDatatypeInterface;
    height: fromDatatype.NumericDatatypeInterface;
    weight: fromDatatype.NumericDatatypeInterface;
    width: fromDatatype.NumericDatatypeInterface;
    length: fromDatatype.NumericDatatypeInterface;
    ecom_sync: boolean;
    serialized: boolean;
    category_group_0_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_0_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_1_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_1_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_2_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_2_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_3_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_3_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_4_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_4_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_5_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_5_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_6_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_6_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_7_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_7_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_8_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_8_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_9_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_9_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_group_10_code: fromDatatype.VarcharArrayDatatypeInterface;
    category_10_code: fromDatatype.VarcharArrayDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: boolean;
    processed: boolean;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;    
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}